module.exports = __webpack_public_path__ + "img/logo.40d24b5d.png";